// Immatriculations : SIV (AB-123-CD), FNI (1234 AB 59) et plaques étrangères.
//
// ⚠️ LE DOUBLE DE `schemas.normaliser_immatriculation` (backend). Si l'une
// change, changer l'autre : un écran plus permissif que le serveur accepte une
// saisie que l'enregistrement refuse ensuite, et un écran plus strict refuse
// un camion que le serveur aurait pris. Rien ne le rappellera.
//
// SIV et FNI se reconnaissent seuls. Une plaque étrangère se DÉCLARE (case à
// cocher) : l'accepter d'office laisserait passer une faute de frappe sur une
// plaque française sans un mot.

const SIV = /^([A-Z]{2})(\d{3})([A-Z]{2})$/;
const FNI = /^(\d{1,4})([A-Z]{1,3})(97[1-6]|2A|2B|0[1-9]|[1-9]\d)$/;
const CARACTERES = /^[A-Z0-9 -]+$/;
export const LONGUEUR_MAX = 15;

export const MESSAGE_FRANCAISE =
  "Format attendu : AA-123-AA, ou 1234 AB 59 pour une ancienne plaque. " +
  "Plaque étrangère ? Cochez la case prévue.";

// Renvoie { valeur } (forme canonique) ou { erreur }.
export function normaliser(saisie, etrangere = false) {
  const v = (saisie || "").trim().toUpperCase().split(/\s+/).filter(Boolean).join(" ");
  if (!v || !CARACTERES.test(v)) {
    return {
      erreur: etrangere ? "Lettres, chiffres, espaces et tirets seulement" : MESSAGE_FRANCAISE,
    };
  }
  const compacte = v.replace(/[ -]/g, "");
  if (etrangere) {
    if (compacte.length < 2 || v.length > LONGUEUR_MAX) {
      return { erreur: `Une plaque étrangère compte de 2 à ${LONGUEUR_MAX} caractères` };
    }
    return { valeur: v };
  }
  let m = compacte.match(SIV);
  if (m) return { valeur: m.slice(1).join("-") };
  m = compacte.match(FNI);
  if (m) return { valeur: m.slice(1).join(" ") };
  return { erreur: MESSAGE_FRANCAISE };
}

// Plaque déjà enregistrée : est-elle étrangère ? (sert à recocher la case à
// la relecture — le serveur ne stocke pas ce drapeau, la plaque le dit seule.)
export function estEtrangere(plaque) {
  return Boolean(plaque) && Boolean(normaliser(plaque, false).erreur);
}

// Aide à la frappe. Majuscules toujours ; sur une plaque qui prend la forme
// SIV (deux lettres d'abord), les tirets se posent seuls, comme avant. Le
// reste s'écrit tel quel et se met en forme en quittant le champ.
export function formaterSaisie(saisie, etrangere = false) {
  const v = saisie.toUpperCase().replace(/[^A-Z0-9 -]/g, "").slice(0, LONGUEUR_MAX);
  if (etrangere) return v;
  const compacte = v.replace(/[ -]/g, "");
  const m = compacte.match(/^([A-Z]{1,2})(\d{0,3})([A-Z]{0,2})$/);
  const formeSiv = m && (m[2].length === 3 || !m[3]) && (m[1].length === 2 || !m[2]);
  if (!formeSiv) return v;
  return [m[1], m[2], m[3]].filter(Boolean).join("-");
}
